<div class="d-flex flex-column recommendation-section">
    <div class="task-content flex-grow-1 overflow-auto pb-2">
        <div class="px-2">
            @if(isLoading) {
            <div class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <p class="text-muted fw-medium">
                        Generating recommended tasks...
                    </p>

                </div>
            </div>
            } @else {
            <div *ngIf="!showAddForm && tasks.length === 0"
                class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <img src="{{ cvaUI_url + '/assets/icons/tasks.svg' }}" alt="Tasks List" aria-hidden="true"
                        class="icon-sm ico-task">

                    <p class="text-muted">
                        You don't have any tasks yet.
                    </p>

                    <button class="btn btn-dark btn-sm" (click)="showAddItemForm()">
                        Add Task
                    </button>
                </div>
            </div>
            <div *ngIf="tasks.length" class="list-group list-group-flush">
                <div *ngFor="let task of tasks; let i = index; trackBy: trackByIndex">
                    <div *ngIf="editIndex === i; else viewMode"
                        class="border rounded shadow-sm p-2 bg-white small mb-2">

                        <div class="d-flex justify-content-between align-items-start">
                            <h5 class="text-dark fw-semibold small mb-2">Edit Task</h5>
                            <button type="button" class="btn btn-sm btn-link p-0" (click)="cancelEdit()" title="Cancel">
                                <i class="bi bi-x-circle text-grey"></i>
                            </button>
                        </div>

                        <form class="d-flex flex-column gap-2" (ngSubmit)="updateTask()" #editForm="ngForm" novalidate>

                            <!-- Category dropdown -->
                            <select class="form-select form-select-sm small" style="height: 30px; font-size: 0.85rem;"
                                [(ngModel)]="editTask.category" name="editCategory{{i}}" required>
                                <option value="" disabled hidden>Select category</option>
                                <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name }}</option>
                            </select>

                            <!-- Task input -->
                            <input type="text" name="edit-title" class="form-control form-control-sm small"
                                style="height: 30px; font-size: 0.85rem;" maxlength="255"
                                placeholder="Enter task title..." #editTaskInput="ngModel" [(ngModel)]="editTask.task"
                                required
                                [ngClass]="{ 'is-invalid': editForm.touched && (editTaskInput.invalid || !editTaskInput.value?.trim()?.length) }" />
                            <div *ngIf="editForm.touched && (editTaskInput.invalid || !editTaskInput.value?.trim()?.length)"
                                class="invalid-feedback d-block m-0">
                                Task title is required.
                            </div>
                            <div class="text-end mt-1">
                                <button type="submit" class="low-h-btn btn btn-sm btn-dark"
                                    [disabled]="editForm.invalid">Update</button>
                            </div>

                        </form>
                    </div>

                    <ng-template #viewMode>
                        <div class="border rounded p-2 mb-2 shadow-sm bg-white">
                            <div class="d-flex align-items-start gap-2">
                                @if(!task.isSaved){
                                <input type="checkbox" (keydown.space)="toggleCheckbox(i)" (click)="toggleCheckbox(i)"
                                    class="cursor-pointer form-check-input mt-1 custom-check-input" name="checkmark"
                                    [checked]="task.checked" />
                                }

                                <div class="flex-grow-1 " [ngClass]="{'ml-1-25':task.isSaved}">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <span class="badge bg-custom-gray text-black border fw-medium">
                                            {{ task.category }}
                                        </span>
                                        <div class="d-flex justify-content-end gap-2">
                                            @if(!task.isSaved){
                                            <button class="btn btn-sm btn-link text-grey p-0 fs-7"
                                                (click)="startEditTask(i); $event.stopPropagation();" title="Edit">
                                                <i class="bi bi-pencil"></i>
                                            </button>
                                            }@else {
                                            <span class="badge bg-success fs-xx-small fw-medium">
                                                <i class="bi bi-check-circle-fill"></i> Task Created
                                            </span>
                                            }
                                        </div>
                                    </div>
                                    <div class="small mt-2">
                                        <p class="mb-0 text-black lh-sm ml-2 text-break">{{ task.task }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>

            </div>

            <div *ngIf="showAddForm" class="task-form border rounded shadow-sm p-2 mb-2 bg-white">

                <div class="d-flex justify-content-between align-items-start">
                    <h5 class="text-dark fw-semibold small mb-2 mb-sm-1">New Task</h5>
                    <button type="button" class="btn btn-sm btn-link p-0" (click)="showAddForm = !showAddForm"
                        title="Close form">
                        <i class="bi bi-x-circle text-grey"></i>
                    </button>
                </div>

                <form class="d-flex flex-column gap-2" (ngSubmit)="addTask()" #taskForm="ngForm" novalidate>

                    <select class="form-select form-select-sm small" style="height: 30px; font-size: 0.85rem;"
                        [(ngModel)]="newTask.category" name="taskCategory" required
                        [ngClass]="{ 'is-invalid': taskForm.submitted && !newTask.category }">
                        <option value="" hidden disabled selected>Select category</option>
                        <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name }}</option>
                    </select>

                    <input type="text" name="add_task" class="form-control form-control-sm small"
                        style="height: 30px; font-size: 0.85rem;" maxlength="255" placeholder="Enter task title..."
                        [(ngModel)]="newTask.task" required #taskInput="ngModel"
                        [ngClass]="{ 'is-invalid': taskForm.touched && (taskInput.invalid || !taskInput.value?.trim()?.length) }" />
                    <div *ngIf="taskForm.touched && (taskInput.invalid || !taskInput.value?.trim()?.length)"
                        class="invalid-feedback d-block m-0">
                        Task title is required.
                    </div>

                    <div class="text-end mt-1">
                        <button type="submit" [disabled]="taskForm.invalid" class="low-h-btn btn btn-sm btn-dark">
                            Add
                        </button>
                    </div>
                </form>
            </div>
            }
        </div>
        <span #bottom></span>
    </div>

    @if(tasks.length){
    <div class="task-actions d-flex justify-content-between align-items-center flex-wrap gap-2 px-2 pt-3 pb-1">
        <button type="button" class="btn btn-dark btn-sm" (click)="showAddItemForm()">
            Add Task
        </button>

        <button type="button" class="btn btn-dark btn-sm" [disabled]="isSubmitDisabled" (click)="postChecked()">
            Post Task
        </button>
    </div>
    }
</div>